<i18n
  src="@/locales/components/views/packing_house/quality_control/process/show_inspect/quality_group_details.yml"
  lang="yaml"
></i18n>
<template>
  <QualityGroupDetailsSamplings
    v-if="use_samplings"
    :quality_attributes="quality_attributes"
    :quality_samplings="quality_samplings"
    :quality_inspect="quality_inspect"
    :quality_group="quality_group"
    :quality_template="quality_template"
  />
  <QualityGroupDetailsVerticalAttrs
    v-else
    :quality_attributes="quality_attributes"
    :quality_samplings="quality_samplings"
    :quality_inspect="quality_inspect"
    :quality_group="quality_group"
    :quality_template="quality_template"
  />
  <div
    v-for="quality_attribute in quality_attributes"
    :key="quality_attribute.id"
  >
    <div v-if="quality_attribute.quality_attribute_ranges.length > 0">
      <AttributeRanges
        :inspect="quality_inspect"
        :quality_attribute="quality_attribute"
      />
    </div>
  </div>
  <div class="bg-white p-4 my-4 rounded-lg" v-show="show_legend">
    <fieldset class="bg-white p-2 rounded-lg border border-slate-300">
      <legend class="text-gray-500">{{ $t("labels.legend") }}</legend>
      <ul class="px-4 grid grid-cols-4">
        <li
          v-for="quality_attribute in quality_attributes"
          :key="quality_attribute.id"
          class="truncate"
        >
          <span class="font-bold pr-3">
            {{ quality_attribute.abbreviation }}
          </span>
          <span
            class="text-gray-700 truncate"
            v-if="quality_attribute.abbreviation"
          >
            {{ quality_attribute.crop_attribute.name }}
          </span>
        </li>
      </ul>
    </fieldset>
  </div>
  <div />
</template>

<script>
import QualityGroupDetailsSamplings from "@/components/views/packing_house/quality_control/process/show_inspect/QualityGroupDetailsSamplings.vue";
import QualityGroupDetailsVerticalAttrs from "@/components/views/packing_house/quality_control/process/show_inspect/QualityGroupDetailsVerticalAttrs.vue";
import AttributeRanges from "./AttributeRanges.vue";
export default {
  components: {
    QualityGroupDetailsSamplings,
    QualityGroupDetailsVerticalAttrs,
    AttributeRanges,
  },
  props: {
    use_samplings: { defualt: true },
    quality_attributes: { required: true },
    quality_samplings: { required: true },
    quality_inspect: { required: true },
    quality_group: { required: true },
    quality_template: { required: true },
  },
  computed: {
    show_legend: function () {
      return (
        this.quality_attributes
          .map((qa) => qa.abbreviation)
          .filter((abbr) => abbr).length > 0
      );
    },
  },
};
</script>

<style>
</style>